import { isPersisted, isPoll } from '@tunasong/schemas'
import React, { useCallback, useState } from 'react'
import type { FC } from 'react'
import { Poll as PollIcon } from '@tunasong/icons'
import {Dialog, ListItemIcon, ListItemText, MenuItem as MuiMenuItem} from '@tunasong/ui-lib'
import type { RenderMenuItemProps } from '@tunasong/plugin-lib'
import Responses from '../responses.js'

const MenuItem: FC<RenderMenuItemProps> = props => {
  const { element, onClose, ...restProps } = props
  const [showDetails, setShowDetails] = useState(false)

  const handleDetails = useCallback(() => setShowDetails(true), [])
  const handleClose = useCallback(() => {
    if (onClose) {
      onClose()
    }

    setShowDetails(false)
  }, [onClose])

  if (!isPoll(element) || !isPersisted(element)) {
    return null
  }

  return (
    <>
      <MuiMenuItem {...restProps} onClick={handleDetails}>
        <ListItemIcon>
          <PollIcon />
        </ListItemIcon>
        <ListItemText>Poll Details</ListItemText>
      </MuiMenuItem>
      <Dialog title="Poll details" open={showDetails} onClose={handleClose} maxWidth="sm" fullWidth={true}>
        <Responses poll={element} />
      </Dialog>
    </>
  )
}

export default MenuItem
